<script setup lang="ts">
import { useUser } from '~/stores/user'
import usePrices from '~/composables/usePrices'
import type { Currency } from '~/types/api'

const props = defineProps<{
  price: number
}>()

const userStore = useUser()
const { formatPrice } = usePrices()

await userStore.init()

const userCurrency = ref<Currency | null>(null)

onMounted(async () => {
  await nextTick()

  if (userStore.canSeePrices) {
    userCurrency.value = await userStore.getUserCurrency()
  }
})

watch(
  () => userStore.canSeePrices,
  async () => {
    if (userStore.canSeePrices) {
      userCurrency.value = await userStore.getUserCurrency()
    } else {
      userCurrency.value = null
    }
  }
)
</script>

<template>
  <p v-if="price">{{ formatPrice(price, userCurrency) }}</p>
</template>

<style scoped lang="scss"></style>
